export class Permisos {
    id: string;
    permUsuariosPublicar: boolean;
    permUsuariosComentar: boolean;
    constructor(id: string, permisosPublicar:boolean,permisosComentar:boolean) {
        this.id = id;
        this.permUsuariosPublicar = permisosPublicar;
        this.permUsuariosComentar = permisosComentar;
      }
}